//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	//#endregion

	//#region Style vars
	//#endregion

	//#region seting vars based off params

	//#endregion

	return {
		outerStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				width: `100%`,
				height: `auto`,
			};
		},
		courseDescriptionStyle: () => {
			return {
				marginTop: '3rem',
			};
		},
		CourseDescriptionV201ContainerStyle: () => {
			return {
				marginTop: `3rem`,
			};
		},
		takeABreakTextStyle: () => {
			return {
				textAlign: 'center',
				padding: '1rem 1rem 0 1rem',
			};
		},
		bannerStyle: () => {
			return {
				marginTop: '1rem',
			};
		},
		titleStyle: () => {
			return {
				width: '100%',
				color: 'black',
				width: '100%',
				textAlign: 'center',
			};
		},
	};
}

export default Styles;
